import React, {ReactElement} from 'react';
import {Icon, Stack, Toggle, TooltipHost} from '@fluentui/react';
import {SettingId} from '../../settings/registry';

interface IToggleFieldProps {
    readonly?: boolean;
    disabled?: boolean;
    label?: string;
    checked?: boolean;
    name?: string;
    onChange?: (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean, name?: string) => void;
    toolTip?: string | ReactElement | ReactElement[] | undefined;
    width?: number;
    inline?: boolean;
    /** Registry identifier, so documentation can deep-link to this field. */
    settingId?: SettingId;
}

const ToggleField: React.FC<IToggleFieldProps> = (props) => {
    const handleChange = (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
        if (props.onChange) {
            props.onChange(ev, checked, props.name);
        }
    }
    // The info icon rides on the label row: part of the label itself, so it stays beside the text whether the
    // label is stacked above the control or inline with it (as a sibling it fell to its own row).
    const label = props.toolTip && props.label
        ? (
            <span style={{display: 'inline-flex', alignItems: 'center', gap: 5}}>
                {props.label}
                <TooltipHost content={props.toolTip}>
                    <Icon iconName="Info" style={{ verticalAlign: 'middle', cursor: 'help' }} />
                </TooltipHost>
            </span>
        )
        : props.label;
    return (<Stack horizontal={props.inline} data-setting-id={props.settingId}>
        <Toggle
            disabled={props.disabled || props.readonly}
            checked={props.checked}
            onChange={handleChange}
            label={label}
            inlineLabel={props.inline}
        />
        {props.toolTip && !props.label && (
            <TooltipHost content={props.toolTip}>
                <Icon iconName="Info" style={{ marginLeft: 5, verticalAlign: 'middle', paddingTop: '6px' }} />
            </TooltipHost>
        )}
    </Stack>)
}

export default ToggleField;